import React from 'react'
import { Col, Form } from 'antd'
import { useTranslation } from 'lib/i18n'

import InputWithoutAutoComplete from 'components/InputWithoutAutoComplete/InputWithoutAutoComplete'
import {
  VIDEO_REQUEST_FROM_NAME,
  VIDEO_REQUEST_IS_GIFT,
} from 'components/ProductPage/shared/FieldConstants'

export default function FromName({ placeholder, label }) {
  const { t } = useTranslation()

  return (
    <Form.Item shouldUpdate>
      {({ getFieldValue }) =>
        Boolean(getFieldValue(VIDEO_REQUEST_IS_GIFT)) && (
          <Col>
            <Form.Item
              name={VIDEO_REQUEST_FROM_NAME}
              label={label ?? t('VideoRequestForm.fromLabel', 'From')}
              rules={[
                {
                  required: true,
                  message: t(
                    'VideoRequestForm.fromRequired',
                    'Fill in your name',
                  ),
                },
              ]}
              data-cy="fromName"
            >
              <InputWithoutAutoComplete
                size="large"
                placeholder={placeholder}
              />
            </Form.Item>
          </Col>
        )
      }
    </Form.Item>
  )
}
